import { SET_FOCUS_NAV_ITEM, SET_FOCUS_DIAG_ITEM } from './mutation-types';

const pluginStoreContentReadEvent = (store, content) => {
  const { $services, $router } = store;
  const { current } = $router.history;
  const { path, query, params } = current;
  $services.events.content.read(
    { ...content, source: query.source, lang: params.lang },
    path,
    'MAYDAY_WEB',
  );
};

export const webKnowledgeFetchPlugin = (store) => {
  const moduleName = 'webKnowledgeModule';

  const focusNavItemMutation = `${moduleName}/${SET_FOCUS_NAV_ITEM}`;
  const focusDiagItemMutation = `${moduleName}/${SET_FOCUS_DIAG_ITEM}`;

  store.subscribe((mutation) => {
    if (mutation.type === focusNavItemMutation) {
      const { payload } = mutation;

      // Only log interactions on Content and Case
      if (!payload || !['Case', 'Content'].includes(payload.__typename)) return;
      pluginStoreContentReadEvent(store, payload);
    }

    if (mutation.type === focusDiagItemMutation) {
      const { payload } = mutation;

      // Only log on Step to avoid double logging
      if (!payload || payload.type !== 'Step') return;

      pluginStoreContentReadEvent(store, payload);
    }
  });
};
